import Default from './Default/Disclaimer';
import AonDisclaimer from './AonDisclaimer/Disclaimer';
import IProfileDisclaimer from './IProfileDisclaimer/Disclaimer';

export default { Default, AonDisclaimer, IProfileDisclaimer };
